import Vue from 'vue'
import Vuex from 'vuex'
import { adminAuthAPI, authAPI } from '../services/api'

Vue.use(Vuex)
const NOTIFICATION_DEFAULT_DURATION = 4200

export default new Vuex.Store({
  state: { user: null, admin: null, notifications: [] },
  getters: {
    adminRole: state => state.admin?.role || '',
    isSuperAdmin: state => state.admin?.role === 'super_admin',
  },
  mutations: {
    SET_USER(state, user) { state.user = user },
    SET_ADMIN(state, admin) { state.admin = admin },
    ADD_NOTIFICATION(state, notification) { state.notifications.push(notification) },
    REMOVE_NOTIFICATION(state, id) { state.notifications = state.notifications.filter(item => item.id !== id) },
  },
  actions: {
    notify({ commit }, notification = {}) {
      const payload = typeof notification === 'string' ? { message: notification } : notification
      const item = {
        id: payload.id || 'notification-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8),
        type: payload.type || 'info',
        title: payload.title || '',
        message: payload.message || '',
        duration: payload.duration === 0 ? 0 : Number(payload.duration || NOTIFICATION_DEFAULT_DURATION),
        actionLabel: payload.actionLabel || '',
        onAction: typeof payload.onAction === 'function' ? payload.onAction : null,
      }
      if (!item.title && !item.message) return null
      commit('ADD_NOTIFICATION', item)
      if (item.duration > 0) setTimeout(() => commit('REMOVE_NOTIFICATION', item.id), item.duration)
      return item.id
    },
    dismissNotification({ commit }, id) { commit('REMOVE_NOTIFICATION', id) },
    async adminLogin({ commit }, { email, password } = {}) {
      const { data } = await adminAuthAPI.login(email, password)
      if (data.token) localStorage.setItem('authToken', data.token)
      localStorage.setItem('isAuthenticated', 'true')
      commit('SET_ADMIN', data.admin || null)
      return data
    },
    async fetchAdminSession({ commit }) {
      const { data } = await adminAuthAPI.me()
      commit('SET_ADMIN', data.admin || null)
      return data.admin
    },
    async userRequestOtp(_, { phone, register = false } = {}) { const { data } = await authAPI.userRequestOtp(phone, { register }); return data },
    async userVerifyOtp({ commit }, { phone, otp, firstname, lastname } = {}) {
      const { data } = await authAPI.userVerifyOtp(phone, otp, { firstname, lastname })
      if (data.token) localStorage.setItem('authToken', data.token)
      localStorage.setItem('isAuthenticated', 'true')
      commit('SET_USER', data.user || { phone, firstname, lastname })
      return data
    },
    async logout({ commit }) {
      try { await adminAuthAPI.logout() } catch (e) { console.warn(e) }
      localStorage.removeItem('authToken')
      localStorage.removeItem('isAuthenticated')
      commit('SET_USER', null)
      commit('SET_ADMIN', null)
    },
  },
})
